import { getCmsPlaceDetailAction } from "../../../Actions/LogicActions/CmsDestination/GetCmsPlaceDetailAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetFamousPlaceActionParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";

class CMSPlaceInitStep extends StepFlow {
  get stepName() {
    return "CMSPlaceInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IGetFamousPlaceActionParams, void>({
        eventName: evtTree.DestinationDetail.Place.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            getCmsPlaceDetailAction.setParams(data!);
            getCmsPlaceDetailAction.execute();
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("CMSPlace Init Step Execute...");
  }
}

export const CMSPlaceInitStepDeclaration = new StepDefinition({
  stepName: "CMSPlaceInit_Step",
  stepClass: CMSPlaceInitStep,
});
